import { gql } from '@apollo/client';

export const draftMessagesQuery = gql`
  query DraftMessages($venueIds: [ID!]!) {
    draftMessages(venueIds: $venueIds) {
      id
      createdAt
      updatedAt
      messagePreviewText
      draft
      event {
        id
        name
        startDate
        planner {
          id
          fullName
          gravatarUrl
        }
      }
    }
  }
`;

export const unsentMessagesQuery = gql`
  query UnsentMessages($venueIds: [ID!]!) {
    unsentMessages(venueIds: $venueIds) {
      id
      createdAt
      updatedAt
      sentAt
      scheduledSendAt
      deliveryState
      messagePreviewText
      subject
      notDeliveredEvents
      draft
      event {
        id
        name
        startDate
        planner {
          id
          fullName
          gravatarUrl
        }
      }
    }
  }
`;

export const scheduledMessagesQuery = gql`
  query ScheduledMessages($venueIds: [ID!]!) {
    scheduledMessages(venueIds: $venueIds) {
      id
      createdAt
      updatedAt
      scheduledSendAt
      messagePreviewText
      subject
      event {
        id
        name
        startDate
        planner {
          id
          fullName
          gravatarUrl
        }
      }
    }
  }
`;

export const cancelScheduledMessageMutation = gql`
  mutation CancelScheduledMessageFromInbox(
    $input: CancelScheduledMessageInput!
  ) {
    cancelScheduledMessage(input: $input) {
      message {
        id
        scheduledSendAt
        draft
        draftRevision
      }
      errors {
        message
      }
    }
  }
`;

export const deleteMessageMutation = gql`
  mutation DeleteMessage($input: DeleteMessageInput!) {
    deleteMessage(input: $input) {
      message {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const retrySendMessageMutation = gql`
  mutation RetrySendMessage($input: RetrySendMessageInput!) {
    retrySendMessage(input: $input) {
      message {
        id
      }
      errors {
        message
      }
    }
  }
`;

export const convertMessageToDraftMutation = gql`
  mutation ConvertMessageToDraft($input: ConvertMessageToDraftInput!) {
    convertMessageToDraft(input: $input) {
      message {
        id
        draft
      }
      errors {
        message
      }
    }
  }
`;

export const inboxEventsQuery = gql`
  query InboxEvents(
    $venueIds: [ID!]!
    $cursor: String
    $ownerIds: [ID!]
    $unread: Boolean
    $archived: Boolean
  ) {
    inboxEvents(
      venueIds: $venueIds
      after: $cursor
      ownerIds: $ownerIds
      unread: $unread
      archived: $archived
    ) {
      totalCount
      unreadCount
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          id
          name
          startDate
          endDate
          startOffset
          endOffset
          lastEmailedAt
          archived
          lastSentMessage {
            id
            messagePreviewText
            sentAt
          }
          planner {
            id
            firstName
            lastName
            fullName
            gravatarUrl
          }
          unreadMessageCount
          status
          user {
            id
            firstName
            lastName
            fullName
            gravatarUrl
          }
        }
      }
    }
  }
`;

export const teamMessageMentionsQuery = gql`
  query TeamMessageMentions(
    $venueIds: [ID!]
    $cursor: String
    $unread: Boolean
  ) {
    teamMessageMentions(venueIds: $venueIds, after: $cursor, unread: $unread) {
      totalCount
      unreadCount
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          createdAt
          previewText
          readByMentionedUserAt
          author {
            id
            fullName
            gravatarUrl
          }
          event {
            id
            name
          }
        }
      }
    }
  }
`;

export const readMentionMutation = gql`
  mutation ReadMention($input: ReadMentionInput!) {
    readMention(input: $input) {
      mention {
        id
        readByMentionedUserAt
      }
      errors {
        message
      }
    }
  }
`;
